export default __webpack_public_path__ + "static/media/icon_clear_filled.1f402ba9.svg";